import React, { useState, useEffect, useRef } from "react"
import { Container, Progress, Row, Col } from "reactstrap"
import { useTranslation } from "react-i18next"
const LinearIndeterminate = () => {
  const { t } = useTranslation()
  const [value, setValue] = useState(0)

  useEffect(() => {
    loading()
  }, [])
  const loading = () => {
    for (let i = 0; i < 101; i++) {
      setValue(i)
    }
  }
  return (
    <Container fluid={true}>
      <Row>
        <Col>
          <div>{t("global:loading")}</div>
          <div className="mb-4">
            <Progress color="primary" value={value} animated></Progress>
          </div>{" "}
        </Col>
      </Row>
    </Container>
  )
}

export default LinearIndeterminate
